module.exports = __webpack_public_path__ + "img/award2020-01.4122cc17.png";